import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Eye, EyeOff } from "lucide-react";
import Swal from "sweetalert2";
import authService from "../services/authService";
import "../components/loading.css"; 
import Watermark from "../components/Watermark";



const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    // Show loading Swal
    Swal.fire({
      title: "Logging in...",
      html: `
        <div class="custom-loading">
          <div class="spinner">
            <img src="/dca1.png" alt="Loading" />
          </div>
          <p>Please hold on while your request is being processed.</p>
        </div>
      `,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      await authService.login(username, password);
      
      // Success notification
      Swal.fire({
        icon: "success",
        title: "Login Successful!",
        html: `Welcome <strong>${username}</strong>. Redirecting to dashboard...`,
        timer: 2000,
        showConfirmButton: false,
      });
      
      setTimeout(() => navigate("/dashboard"), 2000);
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: "Please check your credentials and try again.",
      });
      setError("Invalid credentials. Please try again.");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-black mt-2">
      <div className="relative bg-gradient-to-r from-blue-600 to-yellow-600 text-white w-full max-w-lg p-10 rounded-tr-3xl rounded-bl-3xl shadow-2xl my-10">
        <Watermark />
        <h1 className="text-4xl font-extrabold text-center mb-8 text-black">
          Welcome Back
        </h1>

        {error && <p className="text-red-500 text-center mb-4">{error}</p>}

        <form className="relative space-y-8" onSubmit={handleLogin}>
          <div>
            <label className="block text-xl font-semibold text-black mb-2">
              Username
            </label>
            <input
              type="text"
              className="w-full p-4 rounded-lg bg-gray-900 text-white border border-gray-700 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="relative">
            <label className="block text-xl font-semibold text-black mb-2">
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              className="w-full p-4 rounded-lg bg-gray-900 text-white border border-gray-700 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute inset-y-0 right-4 flex items-center text-gray-400 hover:text-blue-400"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="flex justify-center w-full">
            <button
              type="submit"
              className="p-4 bg-yellow-400 hover:bg-yellow-500 text-black font-bold rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-400 flex items-center justify-center text-xl"
            >
              Login
            </button>
          </motion.div>
        </form>
      </div>
    </div>
  );
};

export default Login;
